import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { getGlobalClasses } from '../../themes';
import UserPicker from '../../components/advancedForm/UserPicker';
import FormComponent from '../../components/FormComponent';
import AuthUserContainer from '../../containers/AuthUser';
import FormDatePicker from '../../components/form/FormDatePicker';
import FormSelect from '../../components/form/FormSelect';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
	};
};

const screenOptions = [
	{
		name: 'Samsung Galaxy Tab E',
		width: 768,
		height: 1024,
	},
	{
		height: 1280,
		width: 800,
		name: 'Samsung Galaxy Tab A',
	},
	{
		height: 1340,
		width: 800,
		name: 'Samsung Galaxy Tab A7 Light',
	},
];

class TestMobile extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			userId: undefined,
			overrideShiftDate: undefined,
			screenIndex: 0,
		};
	}

	render() {
		const { classes } = this.props;
		const screen = screenOptions[this.state.screenIndex];
		return (
			<Paper className={classes.globalMainPaper}>
				<Grid container>
					<Grid item xs={12} md={4}>
						<UserPicker
							{...this.setForm('userId', 'Drivers')}
							selectMultiple={false}
							whoToShow={'driversOnly'}
							//includeHidden={true}
						/>

						<FormDatePicker
							{...this.setForm('overrideShiftDate', 'Shift Date', true)}
							gridProps={{ md: 12 }}
						/>
						<div style={{ marginTop: 10, marginBottom: 10, padding: 10, fontSize: 13 }}>
							Note: If you leave Shift Date blank it will look up the driver's current clocked in
							shift and use that date. If the driver is not clocked in it will produce an error.
						</div>

						<FormSelect
							{...this.setForm('screenIndex', 'Tablet', true)}
							options={screenOptions.map(({ name, width, height }, index) => {
								return {
									value: index,
									display: `${name} (${width} x ${height} resolution)`,
								};
							})}
						/>

						<Button
							color="primary"
							variant="contained"
							aria-label="Logout"
							onClick={this.showDeliveryTickets}
							style={{ marginBottom: 10, marginTop: 10 }}
						>
							Load Sphere Mobile
						</Button>
						<div>Simulating a table 800x1200 in resolution</div>
					</Grid>
					<Grid item xs={12} md={8}>
						{this.state.iframeUrl && (
							<iframe
								key={this.state.refreshId}
								title="deliveryTickets"
								src={this.state.iframeUrl}
								width={screen.width}
								height={screen.height}
								//width="600"
								//height="1080"
								frameBorder="0"
								scrolling="yes"
								allowFullScreen={true}
								style={{ border: '4px solid #ddd' }}
							></iframe>
						)}
					</Grid>
				</Grid>
			</Paper>
		);
	}

	showDeliveryTickets = () => {
		const { showErrors } = this.props;
		const { userId, overrideShiftDate } = this.state;
		if (!userId) {
			console.log('Missing userId');
			return showErrors(['Dude. Pick a driver please']);
		}

		sessionStorage.setItem('testMobile-testUserId', userId);

		if (!overrideShiftDate) {
			sessionStorage.removeItem('testMobile-overrideShiftDate');
		} else {
			sessionStorage.setItem('testMobile-overrideShiftDate', overrideShiftDate);
		}

		let iframeUrl = `/mobile/loads`;
		this.setState({
			refreshId: Math.random(),
			iframeUrl,
		});
	};
}

TestMobile.propTypes = {
	classes: PropTypes.object.isRequired,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles)], AuthUserContainer)(TestMobile);
